export {default} from './AtlasDevices';
